import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import {
  DebitNoteOperationResult,
  DebitNoteDataEntity,
} from "../entities/DebitNoteEntity";

/**
 * Create Zoho Debit Note Use Case
 * Creates a new debit note in the database and pushes it to Zoho Books
 * If debitNoteId is provided, updates the existing debit note instead
 */
export class CreateZohoDebitNoteUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(
    debitNoteData: DebitNoteDataEntity,
    pdfUrl?: string,
    debitNoteId?: number
  ): Promise<DebitNoteOperationResult> {
    return await this.repository.createZohoDebitNote(
      debitNoteData,
      pdfUrl,
      debitNoteId
    );
  }
}

